module.exports = __webpack_public_path__ + "static/g-1-8240c715aa3d638a4bf099ca6c943138.jpg";